import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import SelectableListItem from 'components/Utils/SelectableListItem';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { useAppSelector } from 'careand-redux/store';
import { api } from 'careand-redux/api/ApiThunks';
import { useIsLoading } from 'careand-redux/slices/ui/hooks';
import './style.scss';
import ReceiptBadge from 'components/Payments/ReceiptList/ReceiptBadge';
import DefaultButton from 'components/Utils/NewDefaultButton';
import SendMultipleDocuments from 'components/HealthRecords/Documents/SendMultipleDocuments';
import DefaultModal from 'components/Utils/DefaultModal';
import { getTenantIdentity } from 'hooks/useTenantIdentity';

const ReceiptList = ({ patient, onClick }) => {
  const dispatch = useAppDispatch();
  const receipts = useAppSelector((state) => state.invoices.receipts);
  const loading = useIsLoading(api.Invoices.getReceipts);

  const patientId = patient?.id;

  const patientReceipts = receipts[patientId];

  useEffect(() => {
    if (patientId) {
      dispatch(api.Invoices.getReceipts({ patientId }));
    }
  }, [dispatch, patientId]);

  return (
    <div className="receipt-list" key={patientId}>
      <List>
        <ListItems
          receipts={patientReceipts}
          patient={patient}
          onClick={onClick}
          loading={loading}
        />
      </List>
    </div>
  );
};

const ListItems = React.memo(({ receipts = [], patient, onClick, loading }) => {
  return (
    <>
      {receipts.length > 0 &&
        receipts.map((receipt) => (
          <SelectableListItem
            key={receipt.id}
            item={<SingleItem patient={patient} receipt={receipt} onClick={onClick} />}
          />
        ))}
      {receipts.length === 0 && !loading && <span className="padded-title">No items to show</span>}
    </>
  );
});

const SingleItem = ({ patient, receipt, onClick }) => {
  const [sendModal, setSendModal] = useState(false);

  return (
    <>
      <ReceiptBadge
        key={receipt.id}
        receipt={receipt}
        patient={patient}
        onClick={onClick}
        buttons={
          <>
            <DefaultButton
              name="Email Receipt"
              style={{ width: '200px' }}
              icon="envelope"
              onClick={() => {
                setSendModal(true);
              }}
            />
          </>
        }
      />
      {sendModal && (
        <DefaultModal
          wrap={true}
          title="Email Documents"
          className="large-modal send-multiple-documents-modal"
          padding={false}
          content={
            <SendMultipleDocuments
              patient={patient}
              email={patient.email}
              onClose={() => setSendModal(false)}
              hideContacts={true}
              emailFirst={true}
              hideToggle={true}
              documents={[receipt]}
              emailSubject="Payment Receipt"
              emailBody={`Hi,

Please see attached receipt.

Thanks,
${getTenantIdentity().name}`}
            />
          }
          isOpen={sendModal}
          onRequestClose={() => setSendModal(false)}
        />
      )}
    </>
  );
};

ReceiptList.propTypes = {
  patient: PropTypes.object.isRequired,
};

export default ReceiptList;
